define('cartware/components/Logger',[
	"loglevel"
], function(
	log
) {
	return log;
});
